import { axiosInstance } from '.';
import {
    GetReportedDetailsResponseType,
    GetReportReplyResponseType,
    GetReportReviewResponseType,
    PartnerReportedDetailsRequestType,
    ReportedActionRequestType,
    ReportedDetailsRequestType,
    ReportReplyRequestType,
    ReportReviewRequestType,
} from '../../types/report';

export const reportService = {
    async getReviewsList(params: ReportReviewRequestType) {
        const { data } = await axiosInstance.get(`ReportReviews`, { params });
        return data as GetReportReviewResponseType;
    },

    async getRepliesList(params: ReportReplyRequestType) {
        const { data } = await axiosInstance.get(`ReportReplies`, { params });
        return data as GetReportReplyResponseType;
    },

    async getReportedDetailsList(params: ReportedDetailsRequestType | PartnerReportedDetailsRequestType) {
        const { data } = await axiosInstance.get(`Suspension/GetReportedReviewDetails`, { params });
        return data as GetReportedDetailsResponseType;
    },

    async setReportedAction(params: ReportedActionRequestType) {
        const { data } = await axiosInstance.post(`Suspension/ReportedReviewReplyAction`, params);
        return data as GetReportReplyResponseType;
    },
};
